/**
 * @param    { String }    pattern    pattern like user[firstname]
 * @param    { Object }    state      form state or data (with the trailing first bracket)
 *
 * @return   { FormData }
 **/
export default function getFormData ({ form_data, pattern='', state,
	files_pattern='__files-' })
{
	form_data = form_data || new FormData();

	Object.keys(state)
	.filter(prop => prop.indexOf(files_pattern + pattern) === -1)
	.filter(prop => pattern ? prop.indexOf(pattern) === 0 : true)
	.forEach(function (prop)
	{
		const element = state[prop];

		parse(element, prop);
	});

// __files- is the default pattern (ex: __files-user[logo])
	Object.keys(state)
	.filter(prop => prop.indexOf(files_pattern + pattern) === 0)
	.filter(prop => Array.isArray(state[prop]) && state[prop])
	.forEach(function (prop)
	{
		let previews = state[prop];

	// preview.url -> file is a preview from the server
		previews
		.filter(preview => preview.file && !preview.url)
		.forEach(function (preview)
		{
			form_data.append(prop, preview.file);
		});
	});

	return form_data;

	function parseObject (object, base)
	{
		Object.keys(object).forEach(function (prop)
		{
			const pattern = base + '[' + prop + ']';

			const element = object[prop];

			parse(element, pattern);
		});
	}

	function parseArray (array, base)
	{
		array.forEach(function (element, i)
		{
			const pattern = base + '[' + i + ']';

			parse(element, pattern);
		});
	}

	function parse (element, pattern)
	{
		if (Array.isArray(element))
		{
			parseArray(element, pattern);
		}
		else if (element && typeof element === 'object')
		{
			parseObject(element, pattern);
		}
		else if (typeof element !== 'undefined')
		{
			form_data.append(pattern, element);
		}
	}
}